import * as THREE from "three"
import Experience from "../Experience"

import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js"

export class PlanetLab{
    constructor(){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.orbitPathFile = this.resources.items.orbitModel
        this.orbitPath = this.orbitPathFile.children[0]
        this.orbits = []
        this.planetGroup = new THREE.Group()
        this.planetAngle = 14
        this.planetTilt = this.planetAngle * (Math.PI / 180)
        this.orbitDistance = 180
        this.orbitSpeed = 0.0
        this.offsetRadians = 0.68 // 1 = 180 degrees

        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
        this.setOrbitPaths()
    }

    setGeometry(){
            let labPlanetGeo = new THREE.IcosahedronGeometry(2, 5)
            this.geometry = mergeVertices(labPlanetGeo)
            this.geometry.computeTangents()
    }
    setTextures(){
            
    }
    
    setMaterials(){
        this.material = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            wireframe: true
        })

        this.lineMat = new THREE.LineBasicMaterial({
            color: 0x555555, //555555
            linewidth:1
        })
    }
    
    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.mesh.rotation.order = "ZYX"
        this.mesh.rotation.z = this.planetTilt
        this.scene.add(this.mesh)
    }

    setPosition(){
        // Set the Parent Planet Parameters
        //this.planetTilt = 20 * (Math.PI / 180)
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        
        this.offset = Math.PI * this.offsetRadians
        //this.planetGroup.position.x = this.orbitDistance * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        //this.planetGroup.position.z = this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        //this.planetGroup.position.y = Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        this.scene.add(this.planetGroup)
    }

    setOrbitPaths(){
        this.orbitPath.material = this.lineMat
        let tempPlanetPath

        for(let i = 0; i < 1; i ++){
            const childClone = this.orbitPath.clone()
            this.scene.add(childClone)
            this.orbits.push(childClone)
        }

        [
            tempPlanetPath,
            // tempMoonAPath,
            // tempMoonBPath,
            // tempMoonCPath,
            // tempMoonDPath
        ] = this.orbits

        this.planetPath = tempPlanetPath
        this.planetPath.scale.set(this.orbitDistance, this.orbitDistance, this.orbitDistance)
        this.planetPath.rotation.set(0, 0, this.planetTilt)
    }

    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.05
    }

    orbit(){
        if(this.planetGroup){
            //this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed)))
            //this.mesh.position.z = this.planetGroup.position.z + ( Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed)))
            //this.mesh.position.y = this.planetGroup.position.y + ( Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed)))
            this.planetGroup.position.x = this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
            this.planetGroup.position.z = this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
            this.planetGroup.position.y = this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
            
            this.mesh.position.x = this.planetGroup.position.x
            this.mesh.position.z = this.planetGroup.position.z
            this.mesh.position.y = this.planetGroup.position.y

        }
        else{
            console.log("no Planet Group")
        }

        
    }

}